export default __webpack_public_path__ + "static/media/poster_eventos_desk_2400.2140bb86.webp";